/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// utils
import { generateClasses } from 'utils/generators';
// styles
import injectSheet from 'react-jss';
import styles from 'material/form/form_styles';



/* ========== ~~~~~~~~~~ FORM : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Form extends Component {
	handleFormSubmit = (e) => {
		e.preventDefault()
		// prevent initial submission of form
	}
	handleKeyDown = (e) => {
        if (this.props.handleKeyDown) this.props.handleKeyDown(e);
    };
	render() {
		return (
			<form className={`form ${generateClasses(this.props)} ${this.props.classes.form} processing-${this.props.processing} editable-${this.props.editable}`} name={this.props.name} onKeyDown={this.handleKeyDown} onSubmit={this.handleFormSubmit}>
	        	{this.props.children}
	        </form>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Form);